<app-card [title]="'user.editUser.labels.contacts'" titleSize="large">
    <ng-template #content>
        <div class="input-grid-gaps grid-2col gap-y-6">
            <app-phone-input
                id="phone"
                [disabled]="!canEdit"
                [form]="form"
            ></app-phone-input>
            <app-text-input
                id="fax"
                label="inputs.fax"
                icon="pi-print"
                [disabled]="!canEdit"
                [form]="form">
            </app-text-input>
            <app-phone-input
                id="mobile"
                label="inputs.mobile"
                [disabled]="!canEdit"
                [form]="form"
            ></app-phone-input>
            <app-email-input
                id="personalEmail"
                label="user.fields.personalEmail"
                [disabled]="!canEdit"
                [form]="form">
            </app-email-input>
        </div>
    </ng-template>
</app-card>
